export enum RequestStatus {
  ON_HOLD = 0,
  ACCEPTED = 1,
  DENIED = 2
}
